import { RecordsResultsListItem } from "@js/full_text/search";
import { getInputFromDOM } from "@js/invenio_rdm_records";
import { DepositFormApp } from "@js/invenio_rdm_records/src/deposit/api/DepositFormApp";
import { UPDepositRecordSerializer } from "@js/up/records/deposit/DepositRecordSerializer";
import { ResourceTypeField } from "@js/up/records/deposit/fields";
import {
  BasicInformationSectionExtra,
  MiscInformationSection,
  PublishingSection,
} from "@js/up/records/deposit/sections";
import { parametrize } from "react-overridable";

const depositConfig = getInputFromDOM("deposits-config");
const parametrizedRDMDepositForm = parametrize(DepositFormApp, {
  recordSerializer: new UPDepositRecordSerializer(
    depositConfig?.default_locale,
    depositConfig?.custom_fields.vocabularies,
  ),
});

export const overriddenComponents = {
  // Deposit
  "InvenioAppRdm.Deposit.RDMDepositForm.layout": parametrizedRDMDepositForm,
  // Deposit containers
  "InvenioAppRdm.Deposit.ResourceTypeField.container": ResourceTypeField,
  //Deposit sections
  "InvenioAppRdm.Deposit.AccordionFieldBasicInformation.extra":
    BasicInformationSectionExtra,
  "InvenioAppRdm.Deposit.RecommendedInformation.after.container":
    PublishingSection,
  // Search results
  "InvenioAppRdm.Deposit.CustomFields.container": MiscInformationSection,
  "InvenioAppRDM.RecordsList.RecordsResultsListItem.layout":
    RecordsResultsListItem,
  "InvenioAppRdm.RecordsList.RecordsResultsListItem.layout":
    RecordsResultsListItem,
  "InvenioAppRdm.Search.RecordsResultsListItem.layout": RecordsResultsListItem,
  "InvenioCommunities.DetailsSearch.ResultsList.item": RecordsResultsListItem,
};
